import type { CompanyAction } from 'af-actions/companies/companies.actionCreators';

export type ActionType = CompanyAction;

export * from './companies.actions';
